import { useMutation } from 'react-query';

import { addSiteContactForSite } from 'api/clients/clientSmartCreation/addSiteContactForSite';

export const useCreateSiteContactForSite = () => {
  const { mutate: createSiteContact, isLoading } = useMutation(addSiteContactForSite);

  return { createSiteContact, isLoading };
};
